import React from 'react';

const StyleThumbnail = ({ style, isSelected, onSelect }) => {
  return (
    <button
      onClick={onSelect}
      className={`
        relative w-full aspect-[3/4] rounded-2xl overflow-hidden
        transition-all duration-300 transform hover:scale-105 active:scale-95
        ${isSelected
          ? 'ring-4 ring-[#e5181e] shadow-2xl shadow-[#e5181e]/50'
          : 'ring-2 ring-white/20 hover:ring-[#e5181e]/50'
        }
      `}
    >
      {/* Background Image */}
      <div className="relative w-full h-full">
        <img
          src={style.previewImage}
          alt={style.name}
          className="w-full h-full object-cover"
        />

        {/* Gradient Overlay for better text visibility */}
        <div className={`absolute inset-0 bg-gradient-to-t ${style.gradient} opacity-20`}></div>

        {/* Darkening overlay */}
        <div className="absolute inset-0 bg-black/10"></div>

        {/* Hover State */}
        {!isSelected && (
          <div className="absolute inset-0 bg-[#e5181e]/0 hover:bg-[#e5181e]/30 transition-all duration-300"></div>
        )}
      </div>

      {/* Style Name and Emoji - Bottom */}
      <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/90 to-transparent">
        <div className="flex items-center gap-2">
          <span className="text-2xl">{style.emoji}</span>
          <h3 className="text-sm font-bold text-white leading-tight">{style.name}</h3>
        </div>
      </div>

      {/* Selection Indicator - Checkmark */}
      {isSelected && (
        <div className="absolute top-2 right-2 w-10 h-10 bg-[#e5181e] rounded-full flex items-center justify-center shadow-xl border-2 border-white">
          <span className="text-white text-2xl font-bold">✓</span>
        </div>
      )}

      {/* Selection Glow Effect */}
      {isSelected && (
        <div className="absolute inset-0 bg-[#e5181e]/20 pointer-events-none"></div>
      )}
    </button>
  );
};

export default StyleThumbnail;
